import(/* webpackMode: "eager" */ "/home/devops/azure-agent/_work/2/s/node_modules/next/dist/client/image-component.js");
